import Typography from 'antd/lib/typography';

export const Link = Typography.Link;
